export let CallSource;
(function (CallSource) {
  CallSource["CRM"] = "CRM";
  CallSource["HELP_DESK"] = "HELP_DESK";
  CallSource["INBOX"] = "INBOX";
  CallSource["OUTBOUND_DIALER"] = "OUTBOUND_DIALER";
})(CallSource || (CallSource = {}));